import { uuid6 } from './helpers';

export const uuid = (obj: Record<string, any>): string => {
  let id = uuid6();
  while (obj[id]) {
    id = uuid6();
  }
  return id;
};
